export function gtag(sendTo: string, callback?: Function) {
  if (typeof window !== 'undefined') {
    (window as any).gtag('event', 'conversion', {
      send_to: sendTo,
      event_callback: callback ? callback : () => {},
    });
  }
  return false;
}

export function fbq(event: string) {
  if (typeof window !== 'undefined') {
    (window as any).fbq('track', event);
  }
  return false;
}
